let storage = {
  // localStorage
  // 存储
  set(key, value) {
    window.localStorage.setItem(key, value)
  },
  // 取数据
  get(key) {
    return window.localStorage.getItem(key)
  },
  // 移除
  remove(key) {
    window.localStorage.removeItem(key)
  },
  // sessionStorage
  setS(key, value) {
    window.sessionStorage.setItem(key, value)
  },
  getS(key) {
    return window.sessionStorage.getItem(key)
  }
}

export default storage
